import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import { SiteWorkspaceProvider } from './context/SiteWorkspaceContext';
import { RestaurantProvider } from './context/RestaurantContext';

import AdminLayout from './routes/AdminLayout';
import PublicShell from './routes/PublicShell';
import ProtectedAdminRoute from './admin/components/layout/ProtectedAdminRoute';

import ContactPage from './pages/ContactPage';
import HomePage from './pages/HomePage';
import ItemDetailPage from './pages/ItemDetailPage';
import MenuPage from './pages/MenuPage';
import QRCodePage from './pages/QRCodePage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminCategoriesPage from './pages/AdminCategoriesPage';
import AdminItemsPage from './pages/AdminItemsPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import AdminMediaPage from './pages/AdminMediaPage';

const App: React.FC = () => {
  return (
    <Router>
      <SiteWorkspaceProvider>
        <Routes>
          <Route path="admin" element={<AdminLayout />}>
            <Route index element={<AdminLoginPage />} />
            <Route
              path="dashboard"
              element={
                <ProtectedAdminRoute>
                  <AdminDashboardPage />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="menu/categories"
              element={
                <ProtectedAdminRoute>
                  <AdminCategoriesPage />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="menu/items"
              element={
                <ProtectedAdminRoute>
                  <AdminItemsPage />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="settings"
              element={
                <ProtectedAdminRoute>
                  <AdminSettingsPage />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="media"
              element={
                <ProtectedAdminRoute>
                  <AdminMediaPage />
                </ProtectedAdminRoute>
              }
            />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Route>

          <Route
            element={
              <RestaurantProvider>
                <PublicShell />
              </RestaurantProvider>
            }
          >
            <Route path="/" element={<HomePage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/item/:id" element={<ItemDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/qr-code" element={<QRCodePage />} />
            <Route path="/about" element={<Navigate to="/contact" replace />} />
            <Route path="/drinks" element={<Navigate to="/menu" replace />} />
            <Route path="/drink/:id" element={<Navigate to="/menu" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </SiteWorkspaceProvider>
    </Router>
  );
};

export default App;
